let shipzipDateSelected = sessionStorage.getItem('shipzip_date_selected') === 'true';
// ============================================================
// 1. FETCH INTERCEPT — must be first, before DOMContentLoaded
// ============================================================
const _originalFetch = window.fetch;
window.fetch = function(...args) {
  try {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url ?? '');
    const result = _originalFetch.apply(this, args);
    if (url.includes('/cart/update.js')) {
      if (url.includes('csapp=shipcs')) {
        // This is a ShipZip date selection, not a quantity/item update
        shipzipDateSelected = true;
        sessionStorage.setItem('shipzip_date_selected', 'true');
      }
      result.then(() => validateCart());
    }
    return result;
  } catch(e) {
    return _originalFetch.apply(this, args);
  }
};

// ============================================================
// 2. CONFIG
// ============================================================
const INCOMPATIBLE_COMBINATIONS = [
  {
    substrings: ['-CO', '-IP-CM'],
    message: 'Items for different delivery destinations cannot be ordered together.',
  },
  {
    substrings: ['-CO', '-SS'],
    message: 'Items for different delivery destinations cannot be ordered together.',
  },
  {
    substrings: ['-CO', '-PICKUP'],
    message: 'Items for collection cannot be ordered with delivery items.',
  },
  {
    substrings: ['-IP-CM', '-PICKUP'],
    message: 'Items for collection cannot be ordered with delivery items.',
  },
  {
    substrings: ['-SS', '-PICKUP'],
    message: 'Items for collection cannot be ordered with delivery items.',
  },
  {
    substrings: ['-IP-CM', '-SS'],
    message: 'Items for different delivery destinations cannot be ordered together.',
  },
];

const CHECKOUT_SELECTORS = [
  '[name="checkout"]',
  '.cart__checkout-button',
  'button[data-checkout]',
  '#checkout-button',
  'a[href="/checkout"]',
];

const TURF_MIN_QUANTITY = 20;
const SOIL_PREFIXES = ['SL-', 'BL-'];
const TERMS_CHECKBOX_SELECTOR = '[name="iAgreewptc"]';

// ============================================================
// 3. VALIDATION FUNCTIONS
// ============================================================
function getTurfQuantity(cartItems) {
  return cartItems
    .filter(item => item.sku.includes('TURF-'))
    .reduce((total, item) => total + item.quantity, 0);
}

function getSoilQuantity(cartItems) {
  return cartItems
    .filter(item => SOIL_PREFIXES.some(prefix => item.sku.includes(prefix)))
    .reduce((total, item) => total + item.quantity, 0);
}

function getTurfConflict(cartItems) {
  const hasPickup = cartItems.some(item => item.sku.endsWith('-PICKUP'));
  if (hasPickup) return null;

  const turfQty = getTurfQuantity(cartItems);
  const soilQty = getSoilQuantity(cartItems);

  if (turfQty > 0 && turfQty < TURF_MIN_QUANTITY && soilQty === 0) {
    return {
      message: `A minimum of ${TURF_MIN_QUANTITY} turf items are required to checkout (currently ${turfQty}) if there is no soil in the order.`,
    };
  }
  return null;
}

function getDateConflict(cartAttributes,cartItems) {
  if (!shipzipDateSelected) {
    return { message: 'Please select a delivery or collection date before checking out.' };
  }
  // const date = cartAttributes['Shipping Delivery Date'] || cartAttributes['Pickup Date'] || '';
  // if (!date.trim()) {
  //   return { message: 'Please select a delivery or collection date before checking out.' };
  // }
  const isPickup = cartItems.some(item => item.sku.endsWith('-PICKUP'));
  const date = isPickup
    ? cartAttributes['Pickup Date']
    : cartAttributes['Shipping Delivery Date'];

  if (!date || !date.trim()) {
    return { message: 'Please select a delivery or collection date before checking out.' };
  }
  return null;
}

function getTermsConflict() {
  const termsCheckbox = document.querySelector(TERMS_CHECKBOX_SELECTOR);
  if (!termsCheckbox || !termsCheckbox.checked) {
    return { message: 'Please agree to the terms and conditions before checking out.' };
  }
  return null;
}

// ============================================================
// 4. CART FETCHING
// ============================================================
function getCartItems() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => ({ items: cart.items, attributes: cart.attributes }));
}

function cartHasSku(cartSkus, substring) {
  return cartSkus.some(sku => sku.includes(substring));
}

function getConflicts(cartSkus) {
  return INCOMPATIBLE_COMBINATIONS.filter(({ substrings }) =>
    substrings.every(substring => cartHasSku(cartSkus, substring))
  );
}

// ============================================================
// 5. UI
// ============================================================
function showErrors(conflicts) {
  let errorEl = document.getElementById('cart-sku-errors');

  if (!errorEl) {
    errorEl = document.createElement('div');
    errorEl.id = 'cart-sku-errors';
    errorEl.style.cssText = `
      background: #fef2f2;
      border: 1px solid #fca5a5;
      color: #b91c1c;
      padding: 12px 16px;
      border-radius: 4px;
      margin-bottom: 16px;
      font-size: 14px;
    `;

    const firstBtn = document.querySelector(CHECKOUT_SELECTORS.join(','));
    if (firstBtn) {
      firstBtn.closest('form')?.insertBefore(errorEl, firstBtn)
        ?? firstBtn.parentNode.insertBefore(errorEl, firstBtn);
    } else {
      document.querySelector('cart-items')?.appendChild(errorEl);
    }
  }

  errorEl.innerHTML = conflicts
    .map(c => `<p style="margin:0 0 4px">${c.message}</p>`)
    .join('');
  errorEl.style.display = 'block';
}

function hideErrors() {
  const errorEl = document.getElementById('cart-sku-errors');
  if (errorEl) errorEl.style.display = 'none';
}

function setCheckoutBlocked(blocked) {
  document.querySelectorAll(CHECKOUT_SELECTORS.join(',')).forEach(btn => {
    if (blocked) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.style.opacity = '0.4';
      btn.style.pointerEvents = 'none';
      btn.dataset.skuBlocked = 'true';
    } else if (btn.dataset.skuBlocked) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      delete btn.dataset.skuBlocked;
    }
  });
}

function setDynamicCheckoutBlocked(blocked) {
  const element = document.getElementById('dynamic-checkout-cart');
  if (!element) return;
  element.style.visibility = blocked ? 'hidden' : 'visible';
}

// ============================================================
// 6. MAIN VALIDATE
// ============================================================
function validateCart() {
  getCartItems().then(({ items, attributes }) => {
    const skus = items.map(item => item.sku);
    const conflicts = getConflicts(skus);

    const turfConflict = getTurfConflict(items);
    if (turfConflict) conflicts.push(turfConflict);

    const dateConflict = getDateConflict(attributes, items);
    if (dateConflict) conflicts.push(dateConflict);

    const termsConflict = getTermsConflict();
    if (termsConflict) conflicts.push(termsConflict);

    if (conflicts.length) {
      showErrors(conflicts);
      setCheckoutBlocked(true);
      setDynamicCheckoutBlocked(true);
    } else {
      hideErrors();
      setCheckoutBlocked(false);
      setDynamicCheckoutBlocked(false);
    }
  });
}

// ============================================================
// 7. INIT
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
  validateCart();

  // Terms checkbox change — date is handled via fetch intercept above
  document.addEventListener('change', (e) => {
    if (e.target.matches(TERMS_CHECKBOX_SELECTOR)) {
      validateCart();
    }
  });
});